import { useContext, useCallback } from 'react';
import { useLatest } from 'ahooks';
import { UploadStateContext } from '@/components/upload-core/context';
import { fileToObject, getFileIndex } from '../utils/utils';
export const useOnError = () => {
    const { setValue, onChange, onError } = useContext(UploadStateContext);
    const onChangeRef = useLatest(onChange);
    const onErrorRef = useLatest(onError);
    return useCallback((error, response, _file) => {
        const file = fileToObject(_file, { status: 'error' });
        if (onErrorRef.current) {
            onErrorRef.current(error, response, file);
        }
        setValue((prev) => {
            const fileIndex = getFileIndex(file, prev);
            const value = prev.map((item, index) => {
                if (index !== fileIndex)
                    return item;
                const temp = {
                    ...item,
                    error,
                    errorMsg: error.message,
                    status: 'error',
                };
                return temp;
            });
            onChangeRef.current?.(value, file);
            return value;
        });
    }, [onChangeRef, onErrorRef, setValue]);
};
